import { useQuery } from "@tanstack/react-query";
import { get } from "@/lib/api";

export function JobSelect({ value, onChange, allowNone, noneLabel = "No job (talent pool)", testId = "job-select", required, openOnly = true }) {
  const { data = [] } = useQuery({ queryKey: ["jobs-select"], queryFn: () => get("/jobs") });
  const jobs = data.filter((j) => !openOnly || j.status !== "closed");
  return (
    <select value={value || ""} onChange={(e) => onChange(e.target.value)} required={required} aria-label="Job" data-testid={testId}
      className="h-10 w-full rounded-[5px] border border-line bg-white px-3 text-sm outline-none focus:border-brand/50 focus:ring-2 focus:ring-brand/15">
      <option value="">{allowNone ? noneLabel : "Pick a job…"}</option>
      {jobs.map((j) => <option key={j.id} value={j.id}>{j.title}{j.status !== "open" ? ` (${j.status})` : ""}</option>)}
    </select>
  );
}
